// extracted by mini-css-extract-plugin
export var editButton = "_of-0";